import { useEffect } from "react";
import { create } from "zustand";

/**
 * Recorders on screen that say themselves what being offline means for the
 * recording ("Live transcript paused…", "Offline: recording is being saved
 * on this device"). While one is there, the app-wide offline pill stays
 * hidden so the doctor sees one message, not two.
 */
export const useRecorderOfflineMessageStore = create<{ owners: number }>(
  () => ({ owners: 0 }),
);

export const useOwnOfflineMessage = (active: boolean): void => {
  useEffect(() => {
    if (!active) return;
    useRecorderOfflineMessageStore.setState((state) => ({
      owners: state.owners + 1,
    }));
    return () => {
      useRecorderOfflineMessageStore.setState((state) => ({
        owners: Math.max(0, state.owners - 1),
      }));
    };
  }, [active]);
};
